/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getSingleSelectNames(_ref) {
  var items = _ref.items,
      nameProperty = _ref.nameProperty;

  if (!items || items.length <= 1) {
    return null;
  }

  var names = items.reduce(function (acc, item) {
    var name = item[nameProperty];

    if (acc[name] !== undefined) {
      acc[name] = true;
    } else {
      acc[name] = false;
    }

    return acc;
  }, {});
  return names;
}

var _default = getSingleSelectNames;
exports.default = _default;